"use client"

import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import Layout from "../components/Layout"


const Profile = () => {
  const navigate = useNavigate()
  const [isEditing, setIsEditing] = useState(false)
  const [accountStatus, setAccountStatus] = useState(null)
  const [statusLoading, setStatusLoading] = useState(true)
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    role: "",
   
  })
  const [loading, setLoading] = useState(true)
  const API_BASE_URL = 'https://api.tenarx.net';
  // Fetch user profile data
  const fetchProfileData = async () => {
    try {
      const token = localStorage.getItem("userToken") || localStorage.getItem("token")
      const userId = localStorage.getItem("userId") // Assuming you store user ID
      
      const response = await fetch(`${API_BASE_URL}/api/personal-info/`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })

      if (response.ok) {
        const data = await response.json()
        if (data.success) {
          setFormData({
            firstName: data.data.personalInfo.firstName || "",
            lastName: data.data.personalInfo.lastName || "",
            email: data.data.user.email || "",
            phone: data.data.personalInfo?.phone || "",
            role: data.data.user.role || "",
            
          })
        }
      }
    } catch (error) {
      console.error("Error fetching profile:", error)
    } finally {
      setLoading(false)
    }
  }

  // Fetch account status
  const fetchAccountStatus = async () => {
    try {
      const token = localStorage.getItem("userToken") || localStorage.getItem("token")
      console.log("Token for account status:", token ? "exists" : "missing")
      
      if (!token) {
        console.error("No token found in localStorage")
        setStatusLoading(false)
        return
      }
      
      const response = await fetch(`${API_BASE_URL}/api/auth/account/status`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })

      if (response.ok) {
        const data = await response.json()
        console.log("Account status response:", data)
        setAccountStatus(data)
      } else {
        console.error("Failed to fetch account status:", response.status)
      }
    } catch (error) {
      console.error("Error fetching account status:", error)
    } finally {
      setStatusLoading(false)
    }
  }

  useEffect(() => {
    fetchProfileData()
    fetchAccountStatus()
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const token = localStorage.getItem("userToken") || localStorage.getItem("token")
      const userId = localStorage.getItem("userId")
      
      const response = await fetch(`${API_BASE_URL}/api/personal-info/`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstName: formData.firstName,
          lastName: formData.lastName,
          role: formData.role,
          
          personalInfo: {
            phone: formData.phone,
            
          }
        }),
      })

      if (response.ok) {
        const data = await response.json()
        console.log("Profile updated:", data)
        setIsEditing(false)
        // Optionally refetch data to ensure UI is up to date
        fetchProfileData()
      } else {
        console.error("Failed to update profile")
      }
    } catch (error) {
      console.error("Error updating profile:", error)
    }
  }

  const handleCompleteVerification = () => {
    navigate("/personal-info")
  }

  const getInitials = (firstName, lastName) => {
  const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : '';
  const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
  return `${firstInitial}${lastInitial}`;
};

  if (loading) return <Layout>Loading...</Layout>
  return (
    <Layout>
      <div className="max-w-4xl mx-auto space-y-6">
        {/* Account Status Alert */}
          {!statusLoading && accountStatus && accountStatus.accountStatus !== "active" && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <svg className="h-6 w-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                  />
                </svg>
              </div>
              <div className="ml-3 flex-1">
                <h3 className="text-lg font-medium text-yellow-800">Account Verification Required</h3>
                <p className="text-yellow-700 mt-1">Pending account should complete your personal information</p>
                <div className="mt-4">
                  <button
                    onClick={handleCompleteVerification}
                    className="bg-yellow-600 text-white px-6 py-2 rounded-lg hover:bg-yellow-700 transition-colors font-medium"
                  >
                    Complete Personal Information
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Page Header */}
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Profile</h1>
            <p className="text-gray-600">Manage your account settings and preferences</p>
          </div>
          <button
            onClick={() => setIsEditing(!isEditing)}
            className={`px-4 py-2 rounded-lg font-medium transition-colors ${
              isEditing ? "bg-gray-200 text-gray-700 hover:bg-gray-300" : "bg-blue-600 text-white hover:bg-blue-700"
            }`}
          >
            {isEditing ? "Cancel" : "Edit Profile"}
          </button>
        </div>

        {/* Account Status Card */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Account Status</h3>
          
          {statusLoading ? (
            <div className="flex items-center space-x-3">
              <div className="w-3 h-3 rounded-full bg-gray-400 animate-pulse"></div>
              <span className="text-sm font-medium text-gray-500">Loading...</span>
            </div>
          ) : (
            <>
              <div className="flex items-center space-x-3">
                {console.log("Rendering account status:", accountStatus)}
                {accountStatus?.accountStatus === "active" ? (
                  <>
                    <div className="w-3 h-3 rounded-full bg-green-500"></div>
                    <span className="text-sm font-medium text-gray-700">Active</span>
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      Verified
                    </span>
                  </>
                ) : (
                  <>
                    <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                    <span className="text-sm font-medium text-gray-700">Pending</span>
                    <button
                      onClick={handleCompleteVerification}
                      className="inline-flex items-center px-3 py-1 rounded-md text-xs font-medium bg-yellow-100 text-yellow-800 hover:bg-yellow-200 transition-colors"
                    >
                      Complete Verification
                    </button>
                  </>
                )}
              </div>
              {accountStatus?.message && <p className="text-sm text-gray-600 mt-2">{accountStatus.message}</p>}
              {!accountStatus && <p className="text-sm text-red-600 mt-2">Unable to fetch account status</p>}
            </>
          )}
        </div>

        {/* Profile Card */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          {/* Profile Header */}
          <div className="bg-gradient-to-r from-blue-500 to-purple-600 px-6 py-8">
            <div className="flex items-center space-x-4">
             <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center">
  <span className="text-2xl font-bold text-blue-600">
    {getInitials(formData.firstName, formData.lastName)}
  </span>
</div>
              <div className="text-white">
                <h2 className="text-2xl font-bold">
                  {formData.firstName} {formData.lastName}
                </h2>
                <p className="text-blue-100">
                  {formData.role} • {formData.department}
                </p>
              </div>
            </div>
          </div>

          {/* Profile Form */}
          <div className="p-6">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">First Name</label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    disabled={!isEditing}
                    className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      !isEditing ? "bg-gray-50 text-gray-500" : ""
                    }`}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Last Name</label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    disabled={!isEditing}
                    className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      !isEditing ? "bg-gray-50 text-gray-500" : ""
                    }`}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    disabled={!isEditing}
                    className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      !isEditing ? "bg-gray-50 text-gray-500" : ""
                    }`}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    disabled={!isEditing}
                    className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      !isEditing ? "bg-gray-50 text-gray-500" : ""
                    }`}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Role</label>
                  <input
                    type="text"
                    name="role"
                    value={formData.role}
                    onChange={handleChange}
                    disabled={!isEditing}
                    className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      !isEditing ? "bg-gray-50 text-gray-500" : ""
                    }`}
                  />
                </div>
                
              </div>

              

              {isEditing && (
                <div className="flex justify-end space-x-3">
                  <button
                    type="button"
                    onClick={() => setIsEditing(false)}
                    className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                  >
                    Save Changes
                  </button>
                </div>
              )}
            </form>
          </div>
        </div>

        
       
      </div>
    </Layout>
  )
}

export default Profile
